var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-panel',{attrs:{"locations":_vm.locations,"locationStats":_vm.locationStats}})}
var staticRenderFns = []

export { render, staticRenderFns }